import React from 'react';
import PageContainer from '../../../components/layout/PageContainer';
import PermissionsEditor from './PermissionsEditor';

const ConfigurationPermissions = () => (
  <PageContainer maxWidth="full" padding="md">
    <PermissionsEditor />
  </PageContainer>
);

export default ConfigurationPermissions;
